/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Included_3Inputs */

const tr_landing_pricing_included_3 = /** @type {(inputs: Landing_Pricing_Included_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz güncelleme`)
};

const en_landing_pricing_included_3 = /** @type {(inputs: Landing_Pricing_Included_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free updates`)
};

const de_landing_pricing_included_3 = /** @type {(inputs: Landing_Pricing_Included_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Updates`)
};

const ru_landing_pricing_included_3 = /** @type {(inputs: Landing_Pricing_Included_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные обновления`)
};

/**
* | output |
* | --- |
* | "Free updates" |
*
* @param {Landing_Pricing_Included_3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_included_3 = /** @type {((inputs?: Landing_Pricing_Included_3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Included_3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_included_3(inputs)
	if (locale === "de") return de_landing_pricing_included_3(inputs)
	if (locale === "ru") return ru_landing_pricing_included_3(inputs)
	return tr_landing_pricing_included_3(inputs)
});